import { render, staticRenderFns } from "./GroupsIcon.vue?vue&type=template&id=ad2f0c9c"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ad2f0c9c')) {
      api.createRecord('ad2f0c9c', component.options)
    } else {
      api.reload('ad2f0c9c', component.options)
    }
    module.hot.accept("./GroupsIcon.vue?vue&type=template&id=ad2f0c9c", function () {
      api.rerender('ad2f0c9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/GroupsIcon.vue"
export default component.exports